import React, { createContext, useContext, useState, useCallback } from 'react';
import { stocksApi } from '../utils/api';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStocks = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await stocksApi.getAll(params);
      setStocks(res.data.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load stocks');
    } finally {
      setLoading(false);
    }
  }, []);

  const addStock = useCallback(async (data) => {
    const res = await stocksApi.create(data);
    await fetchStocks();
    return res.data;
  }, [fetchStocks]);

  const deleteStock = useCallback(async (id) => {
    await stocksApi.delete(id);
    setStocks(prev => prev.filter(s => s._id !== id));
  }, []);

  return (
    <AppContext.Provider value={{
      stocks, loading, error,
      fetchStocks, addStock, deleteStock
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
